export default __webpack_public_path__ + "media/mock/src/img/logo_diners-c78044216afdd5c51bbe4d28f05806ac.png";